/**
 * Mid-stay change-room / upgrade: close historical nights, keep the live segment.
 *
 * Past nights (date < fromDate) are marked checkout so the old room is released.
 * If the stream has no night on/after fromDate (checkout morning / last occupied
 * night), that remaining night is still in-house and must be moved, not checked out.
 */
export function itemDateKey(item) {
  if (!item?.date) return '';
  const raw = item.date;
  if (raw && typeof raw.format === 'function') return raw.format('YYYY-MM-DD');
  return String(raw).slice(0, 10);
}

export function streamHasOpenNightOnOrAfter(items, fromDateStr) {
  if (!fromDateStr) return false;
  return (items || []).some((item) => {
    if (item?.checkout === true || item?.checkout === 1 || item?.checkout === 'true') {
      return false;
    }
    const dateStr = itemDateKey(item);
    return Boolean(dateStr && dateStr >= fromDateStr);
  });
}

export function shouldCheckoutOldRoomSegment(item, fromDateStr, streamItems) {
  const dateStr = itemDateKey(item);
  if (!dateStr || !fromDateStr || dateStr >= fromDateStr) return false;
  return streamHasOpenNightOnOrAfter(streamItems, fromDateStr);
}
